<div class="filter-control">
  <fsx-select
    label="Documents"
    [control]="formControl"
    [options]="documentOptions">
  </fsx-select>
</div>